module.exports = __webpack_public_path__ + "assets/img/dzh-23.ffd2b506.jpg";